// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projects {
  padding: 120px 0;
  background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%);
}

.projects-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.project-card {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

.project-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.2);
}

.project-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.project-title {
  font-size: 1.5rem;
  color: #2c3e50;
  margin: 0;
}

.project-year {
  color: #3498db;
  font-weight: 500;
}

.project-description {
  color: #6c757d;
  margin-bottom: 1.5rem;
  line-height: 1.6;
}

.project-technologies {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.tech-badge {
  background: rgba(52, 152, 219, 0.1);
  color: #3498db;
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.tech-badge:hover {
  background: rgba(52, 152, 219, 0.2);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .projects-grid {
    grid-template-columns: 1fr;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Projects/Projects.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".projects {\n  padding: 120px 0;\n  background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%);\n}\n\n.projects-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.projects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-top: 3rem;\n}\n\n.project-card {\n  background: white;\n  border-radius: 20px;\n  padding: 2rem;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.project-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 20px 40px rgba(0,0,0,0.2);\n}\n\n.project-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.project-title {\n  font-size: 1.5rem;\n  color: #2c3e50;\n  margin: 0;\n}\n\n.project-year {\n  color: #3498db;\n  font-weight: 500;\n}\n\n.project-description {\n  color: #6c757d;\n  margin-bottom: 1.5rem;\n  line-height: 1.6;\n}\n\n.project-technologies {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.tech-badge {\n  background: rgba(52, 152, 219, 0.1);\n  color: #3498db;\n  padding: 0.3rem 0.8rem;\n  border-radius: 15px;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.tech-badge:hover {\n  background: rgba(52, 152, 219, 0.2);\n  transform: translateY(-2px);\n}\n\n@media (max-width: 768px) {\n  .projects-grid {\n    grid-template-columns: 1fr;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
